import { useCallback } from "react";
import { isBoolean } from "lodash";
import { useFeatureStore } from "./useFeatureStore";
export const useGetPostHogFeature = () => {
    const { payloads } = useFeatureStore();
    return useCallback((flag) => payloads?.[flag], [payloads]);
};
export const usePostHogFeature = (flag) => {
    const { isLoaded } = useFeatureStore();
    const getFeature = useGetPostHogFeature();
    const payload = getFeature(flag);
    return {
        isLoaded,
        payload,
        isEnabled: isBoolean(payload) && payload === true,
    };
};
export const usePostHogFeatures = (flags) => {
    const { isLoaded } = useFeatureStore();
    const getFeature = useGetPostHogFeature();
    const payloads = flags.map(getFeature);
    return {
        isLoaded,
        payloads,
        areEnabled: payloads.map((payload) => isBoolean(payload) && payload === true),
    };
};
